// Stylesheets
import './assets/scss/site.scss';

import { typewriter } from './assets/modules/_typewriter';
import { hover } from './assets/modules/hover';
import { accordion } from './assets/modules/accordion';
import { home } from './assets/modules/home';
import { profile } from './assets/modules/profile';

hover();
accordion();

const init = () => {
  home();
  profile();
}

document.body.classList.add('is-init')
setTimeout(() => {
  typewriter(document.querySelector('.js-identity-text'));
  setTimeout(init,1300)
}, 1700)